import React from 'react';
import clsx from 'clsx';

import Container from '@common/Container';
import Heading from '@common/Heading';
import Section from '@common/Section';
import Row from '@common/Row';
import Img from '@common/Image';
import Link from '@common/Link';

import { departmentLink, departmentIcon } from '@styles/modules/careers.module.scss';

const Default = ({ data }) => {
  const {
    title,
    showTitle,
    list,
    bgColour
  } = data;
  return (
    <Section className={clsx({[`bg-${bgColour} py-5`]: bgColour })}>
      <Container>
        {(showTitle && title) && <Heading type='h2' className='mx-auto mb-4 col-lg-10 text-center'>{title}</Heading>}
        <div className={`d-flex flex-wrap align-items-center justify-content-center justify-content-xl-start`}>
          {list && list.map((department, index) => (
            <Link key={index} to={department.link} className={clsx('d-flex flex-column text-black', departmentLink)}>
              {department.image &&
                <Img image={department.image.gatsbyImageData} file={department.image.file} className={departmentIcon}/>
              }
              {department.title &&
                <h3 className='h4'>{department.title}</h3>
              }
            </Link>
          ))}
        </div>
      </Container>
    </Section>
  )
}

export default Default
